import RepositoryFactory from '@/repository/RepositoryFactory';
import { PutDutyOrderRequest, ResponseDuty } from '@/model/repository';
import { compareShiftCategoricalItem } from '@/service/shift/categoryComparator';
const shiftServiceRepositories = RepositoryFactory.shiftService;

/**
 * 業務を並び替え
 */
export const updateDutyOrders = async (duties: ResponseDuty[]) => {
  // APIでバックエンドのデータを新しい並び順で更新する
  const payload: PutDutyOrderRequest = {
    dutyIds: duties.filter((duty) => !duty.disabled).map((duty) => duty.dutyId),
  };
  const response = await shiftServiceRepositories.dutyOrders.update(payload);
  // レスポンスのorderを画面のモデルに反映する
  const idOrderMap = response.data.reduce((map, duty) => {
    map.set(duty.dutyId, duty.order);
    return map;
  }, new Map<string, number>());
  const result = duties.map((duty) => ({
    ...duty,
    order: idOrderMap.get(duty.dutyId) || 0,
  }));
  // ソート
  sortDuties(result);
  return result;
};

/**
 * 業務の並び替え
 */
export const sortDuties = (duties: ResponseDuty[]) => {
  const patternMapper = (duty: ResponseDuty) => ({
    id: duty.dutyId,
    ...duty,
  });
  duties.sort((a, b) => compareShiftCategoricalItem(patternMapper(a), patternMapper(b)));
};
